import { Component, Input } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'sana-tp-sekeleton-loading',
  imports: [
    Skeleton
  ],
  templateUrl: './sekeleton-loading.component.html',
  styleUrl: './sekeleton-loading.component.scss'
})
export class SekeletonLoadingComponent {
}
